/**
 * @flow
 * @relayHash d73a3027a8409f78da075aae5e27a097
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ArticleStateType = "available" | "deleted" | "draft" | "%future added value";
export type ArticleEditInput = {
  id: string,
  slug?: ?string,
  title: string,
  previewPicture?: ?string,
  previewAttribution?: ?string,
  body: string,
  bodyHtml: string,
  lead: string,
  section: string,
  category: string,
  topics?: ?$ReadOnlyArray<?string>,
  linkedArticles?: ?$ReadOnlyArray<?string>,
  author: string,
  yaGenre: string,
  hidden?: ?boolean,
  isArticleOfHour?: ?boolean,
  isEvent?: ?boolean,
  isMainNews?: ?boolean,
  infostring?: ?boolean,
  infostring_hot?: ?boolean,
  showInYandexNews?: ?boolean,
  showInYandexZen?: ?boolean,
  evergreen?: ?boolean,
  availableAt?: ?string,
  seoTitle?: ?string,
  seoDescription?: ?string,
  seoKeywords?: ?string,
  preview?: ?string,
  combinedPreviewVideo?: ?string,
  mediaFiles?: ?$ReadOnlyArray<?string>,
  changesCount?: ?number,
  state: ArticleStateType,
  mainPageOrder: number,
  clientMutationId?: ?string,
};
export type ArticleEditMutationVariables = {|
  input: ArticleEditInput
|};
export type ArticleEditMutationResponse = {|
  +ArticleEdit: ?{|
    +article: ?{|
      +id: string
    |},
    +error: ?string,
  |}
|};
export type ArticleEditMutation = {|
  variables: ArticleEditMutationVariables,
  response: ArticleEditMutationResponse,
|};
*/


/*
mutation ArticleEditMutation(
  $input: ArticleEditInput!
) {
  ArticleEdit(input: $input) {
    article {
      id
    }
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ArticleEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "ArticleEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ArticleEditInput!"
      }
    ],
    "concreteType": "ArticleEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "article",
        "storageKey": null,
        "args": null,
        "concreteType": "Article",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ArticleEditMutation",
  "id": null,
  "text": "mutation ArticleEditMutation(\n  $input: ArticleEditInput!\n) {\n  ArticleEdit(input: $input) {\n    article {\n      id\n    }\n    error\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ArticleEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ArticleEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '62ff928de46436167f37d2830060fbd4';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/ArticleEditMutation.graphql.js